/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type ItemDisplayPromoCodeWrapper_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type CartItemPromoCode_user$ref: FragmentReference;
export type CartItemPromoCode_user = {|
  +serviceId: ?string,
  +$fragmentRefs: ItemDisplayPromoCodeWrapper_user$ref,
  +$refType: CartItemPromoCode_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "CartItemPromoCode_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "ItemDisplayPromoCodeWrapper_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'bac8cd3f8a9db178fe62263e1496b76e';
module.exports = node;
